import axios from 'axios';
import { APP_DOMAIN, CHAT_API_URL } from 'appenv';
import { TwilioMessageAttributes } from 'models/twilio';

export const getTwilioJwt = async (participantId: string): Promise<string | null> => {
  try {
    const { data } = await axios.get(`${CHAT_API_URL}/token/${participantId}/${APP_DOMAIN}`);
    if (data.success) return data.result;
    throw new Error('Failed to GET Twilio JWT Token');
  } catch (e) {
    console.error(e.message);
    return null;
  }
};

export const leaveGroupChat = async (participantId: string, conversationSid: string) => {
  try {
    const { data } = await axios.post(`${CHAT_API_URL}/leaveConversation/${APP_DOMAIN}`, {
      conversationSid,
      attendeeUuid: participantId,
    });
    if (data.success) return true;
    throw new Error('Failed to leave group chat');
  } catch (e) {
    console.error(e.message);
    return false;
  }
};

/**
 * @description API Call to join a converastion
 * @param participantId: UUID of participant
 * @param identifier: Can be conversationSid or uniqueName
 * @returns void
 */
export const joinConversationRequest = async (participantId: string, identifier: string) => {
  try {
    const { data } = await axios.post(`${CHAT_API_URL}/joinConversation/${APP_DOMAIN}`, {
      conversationSid: identifier,
      attendeeUuid: participantId,
    });
    if (data.success) return true;
    throw new Error('Failed to join group chat');
  } catch (e) {
    console.error(e.message);
    return false;
  }
};

export const sendAnnouncement = async (participantId: string, message: string, messageAttributes: TwilioMessageAttributes = {}) => {
  try {
    const { data } = await axios.post(`${CHAT_API_URL}/sendAnnouncement/${APP_DOMAIN}`, {
      uuid: participantId,
      message,
      messageAttributes,
    });
    if (data?.success) return true;
    throw new Error('Failed to send announcement, please check your permissions');
  } catch (e) {
    console.error('Error: ', e.message);
    return false;
  }
};
